import { SvgIcon } from '@mui/material';
import type { SectionPermission } from '@stm/contracts';

const paths: Record<SectionPermission, string> = {
  'overview.view': 'M3 3h7v7H3z M14 3h7v7h-7z M3 14h7v7H3z M14 14h7v7h-7z',
  'athletes.view':
    'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8 M22 21v-2a4 4 0 0 0-3-3.87 M16 3.13a4 4 0 0 1 0 7.75',
  'teams.view': 'M12 3 3 7v6c0 5 9 9 9 9s9-4 9-9V7z M8 12l3 3 5-5',
  'calendar.view':
    'M5 5h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z M16 3v4 M8 3v4 M3 11h18 M8 15h2 M14 15h2',
  'training.view': 'M3 8v8 M6 6v12 M6 12h12 M18 6v12 M21 8v8',
  'assessments.view': 'M4 3v18h17 M8 16l4-5 4 2 5-7',
  'billing.view': 'M5 3h14v18l-3-2-4 2-4-2-3 2z M9 7h6 M9 11h6 M9 15h3',
  'payments.view':
    'M4 5h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z M2 10h20 M6 15h3',
  'competitions.view':
    'M8 3h8v7a4 4 0 0 1-8 0z M8 5H4v3a4 4 0 0 0 4 4 M16 5h4v3a4 4 0 0 1-4 4 M12 14v5 M8 21h8 M9 19h6',
  'reports.view': 'M5 3h10l4 4v14H5z M14 3v5h5 M9 12h6 M9 16h6',
  'settings.view':
    'M9 3h6l1 3 3 1 2 5-2 5-3 1-1 3H9l-1-3-3-1-2-5 2-5 3-1z M15 12a3 3 0 1 0-6 0 3 3 0 0 0 6 0',
};

export function NavigationIcon({
  permission,
}: {
  permission: SectionPermission;
}): React.JSX.Element {
  return (
    <SvgIcon sx={{ fontSize: 21 }}>
      <path
        d={paths[permission]}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
